import {Checkbox as MUICheckbox, FormControlLabel} from "@material-ui/core";
import React, {useCallback} from "react";
import {Colours, styled} from "../../../styles";

export type CheckboxProps = {
    className?: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
};

function Checkbox(props: CheckboxProps) {
    const { className, label, checked: isChecked, onChange } = props;

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        onChange(checked);
    }, [onChange]);

    return (
        <FormControlLabel className={className}
                          control={<Main checked={isChecked}
                                         onChange={handleChange} />}
                          label={label} />
    );
}

const Main = styled(MUICheckbox)`
    color: ${Colours.BLUE}!important;
`;

export default Checkbox;
